export interface NucleusWorkflowsEnv {
  DEV?: boolean;
  VITE_ENABLE_NUCLEUS_WORKFLOWS?: string;
}

export function isNucleusWorkflowsEnabled(env: NucleusWorkflowsEnv): boolean {
  if (env.VITE_ENABLE_NUCLEUS_WORKFLOWS === "true") {
    return true;
  }

  if (env.VITE_ENABLE_NUCLEUS_WORKFLOWS === "false") {
    return false;
  }

  return env.DEV === true;
}
